(() => {
  const data = document.getElementById('JoyFindterLocale');
  if (!data) return;
  const config = JSON.parse(data.textContent);
  const rootPath = config.root.replace(/\/$/, '');
  let scheduled = false;
  function localize() {
    scheduled = false;
    const root = document.querySelector('fdt-search-filters');
    if (!root) return;
    root.querySelectorAll('a[href]').forEach(link => {
      const url = new URL(link.href, location.origin);
      if (url.origin !== location.origin) return;
      const path = url.pathname.replace(/^\/(ru|uk)(?=\/|$)/, '');
      if (/^\/(products|collections)(\/|$)/.test(path)) {
        const target = rootPath + path + url.search + url.hash;
        if (link.getAttribute('href') !== target) link.setAttribute('href', target);
      }
      const handle = path.match(/^\/products\/([^/]+)/)?.[1];
      const item = config.products[handle];
      if (!item) return;
      const image = link.querySelector('img');
      if (image) {
        if (image.alt !== item.title) image.alt = item.title;
      } else if (link.textContent.trim() && link.textContent.trim() !== item.title) {
        link.textContent = item.title;
      }
    });
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let text;
    while ((text = walker.nextNode())) {
      if (/^(SCRIPT|STYLE)$/.test(text.parentElement?.tagName)) continue;
      const key = text.nodeValue.trim();
      const value = config.labels[key] || (/^\d+ Produkte$/.test(key) ? config.labels.Produkte + ': ' + key.split(' ')[0] : null);
      if (value && value !== key) text.nodeValue = text.nodeValue.replace(key, value);
    }
  }
  const observer = new MutationObserver(records => {
    const relevant = records.some(record => (record.target.nodeType === 1 ? record.target : record.target.parentElement)?.closest('fdt-search-filters') || [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('fdt-search-filters') || node.querySelector('fdt-search-filters'))));
    if (!relevant || scheduled) return;
    scheduled = true;
    requestAnimationFrame(localize);
  });
  observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  localize();
})();
